import React from "react";
import { Button, NewTab, PageTabAdv } from "../../components";
import PersonalDetails from "./MyProfileTabs/PersonalDetails";
import ChangePassword from "./MyProfileTabs/ChangePassword";
import MySignature from "./MyProfileTabs/MySignature";
import { useNavigate } from "react-router-dom";

const MyProfile = () => {
  const navigate = useNavigate();
  const myProfileMenus = [
    {
      title: "Personal Details",
      page: <PersonalDetails />,
      type: "main",
    },
    {
      title: "Change Password",
      page: <ChangePassword />,
      type: "main",
    },
    {
      title: "My Signature",
      page: <MySignature />,
      type: "main",
    },
  ];
  return (
    <div>
      <Button
        variant="text"
        icon="arrow_left_alt"
        title={"My Profile"}
        color="black"
        className="!px-0"
        onClick={() => navigate("/ats/leads")}
      />
      <div className="flex flex-1 my-3">
        <NewTab
          tabs={myProfileMenus}
          color="black"
          variant="text"
          activeVariant="text"
          mode="url"
          tabId="my-profile"
        />
      </div>
    </div>
  );
};

export default MyProfile;
